var map = {
	"./OK.png": 39,
	"./aziinback.jpg": 121,
	"./joy.png": 40,
	"./marker-ayultai.png": 56,
	"./marker-elgeemedeerei.png": 57,
	"./marker-ganbei.png": 58,
	"./marker-tuluu.png": 59,
	"./marker-turaanadaa.png": 60,
	"./shamrock.png": 41,
	"./skull.png": 42,
	"./wall-ayultai.jpg": 269,
	"./wall-dontoi.png": 61,
	"./wall-elgeemedeerei.png": 62,
	"./wall-ganbei.png": 63,
	"./wall-tuluu.jpg": 270,
	"./wall-turaanadaa.png": 64,
	"./wheel-ayultai.png": 65,
	"./wheel-dontoi.png": 66,
	"./wheel-elgeemedeerei.png": 67,
	"./wheel-ganbei.png": 68,
	"./wheel-tuluu.png": 69,
	"./wheel-turaanadaa.png": 70
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;